<script>
export default {
	methods:{
		data: function(){
			return {
				m_bDispTimerEnable:true,
			};
		},
		/**
		 * IE と chrome に対応した表示アニメーション処理
		 */
		setDispTimer:function(sel,tm, retry=0){
			if(this.m_bDispTimerEnable == false)return;
			if( $(sel) && $(sel)[0])
			{
				var wnd = $(sel);
				wnd.css("width","100%");
				wnd.css("height","100%");
				wnd.css("background-color","rgba(255,255,255,0.001)");
				wnd.css("position","absolute");
				wnd.css("top","0");
				wnd.css("left","0");
				wnd.css("z-index","920");
				wnd.css("opacity",0.2);
				wnd.animate({opacity:1.0}, tm, 'swing',function(){
					wnd.css("background-color","null");
					wnd.css("height","0");
				});
			}
			else{
				if(retry < 100){
					var target = this;
					this.$nextTick(function(){ 
						setTimeout(target.setDispTimer(sel,
														tm,
														retry+1),
									10);});
				}
			}
		},
	}
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/common/disptimer.mixin.vue